export const STATUS = {
  ASSET: {
    OWNED_AND_USED: "owned and used",
    OWNED_AND_LEASED_OUT: "owned and leased out",
    OUTSOURCED: "outsourced",
  },
};

export const EMISSION_GROUP = {
  FUEL: "Fuel",
  ENERGY: "Energy",
  FIRE_EXTINGUISHING: "Fire Extinguishing",
};

export const ASSET_STATUS_ALLOWED_EMISSION_GROUPS: Record<string, string[]> = {
  [STATUS.ASSET.OWNED_AND_LEASED_OUT]: [EMISSION_GROUP.FUEL, EMISSION_GROUP.ENERGY],
  [STATUS.ASSET.OUTSOURCED]: [EMISSION_GROUP.FUEL, EMISSION_GROUP.FIRE_EXTINGUISHING],
};

export const ASSET_STATUS_EMISSION_GROUP_ERROR_KEY: Record<string, string> = {
  [STATUS.ASSET.OWNED_AND_LEASED_OUT]:
    "Asset-Status-Owned-Leased-Out-Requires-Fuel-Or-Energy",
  [STATUS.ASSET.OUTSOURCED]:
    "Asset-Status-Outsourced-Requires-Fuel-Or-Fire-Extinguishing",
};
